import { render, staticRenderFns } from "./VPriceRoleForm.vue?vue&type=template&id=50cf8b8e&"
import script from "./VPriceRoleForm.vue?vue&type=script&lang=js&"
export * from "./VPriceRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports